import type { MissionSummary } from '@wwf/sdk';
import { missionSummaryToInput, type MissionInput } from '@domain/mission';

/** Map a mission show record to react-admin create form default values (no id / report / participants). */
export function missionSummaryToDuplicateDefaults(
    record: MissionSummary
): Partial<MissionInput> {
    const {
        id: _id,
        status: _status,
        report: _report,
        reportSentDate: _reportSentDate,
        startDate: _startDate,
        endDate: _endDate,
        ...duplicate
    } = missionSummaryToInput(record);

    return {
        ...duplicate,
        sessions: duplicate.sessions?.map(({ id: _id, ...session }) => ({
            ...session,
            id: null,
        })) ?? [
            {
                id: null,
                label: null,
                startDate: null,
                endDate: null,
                contactId: null,
                sortOrder: 0,
            },
        ],
    };
}
